/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreStandardSubtaskUpdateDto } from '../../models/core-standard-subtask-update-dto';
import { CoreStandardTaskResponseDto } from '../../models/core-standard-task-response-dto';

export interface StandardTasksControllerUpdateSubtask$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the standard task.
 */
  id: string;

/**
 * The code of the subtask to update.
 */
  subtaskCode: string;
      body: CoreStandardSubtaskUpdateDto
}

export function standardTasksControllerUpdateSubtask(http: HttpClient, rootUrl: string, params: StandardTasksControllerUpdateSubtask$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreStandardTaskResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, standardTasksControllerUpdateSubtask.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.path('subtaskCode', params.subtaskCode, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreStandardTaskResponseDto>;
    })
  );
}

standardTasksControllerUpdateSubtask.PATH = '/o2-core/standard-tasks/{tenant}/{id}/subtasks/{subtaskCode}';
